import {
  fetchServices,
  storeFileRefreshment,
  storeReceiptMealPlan,
  getCurrencies,
  getDataBank,
  getDataFields,
  getPricePersonRefreshment,
  checkValidatorField,
  getCountrys,
  getListMealPlanReceiptInfo,
  getMealPlanReceiptByVoucherCode,
  getInfoMealPlanPayment
} from '@/api/service'

const getInfoMealPlan = (context, voucherCode) => {
  getInfoMealPlanPayment(voucherCode).then((response) => {
    context.commit('MEALPLAN_INFO', response)
  })
}

const resetMealPlanInfo = (context) => {
  context.commit('RESET_MEALPLAN_INFO')
}

const uploadImg = (context, data) => {
  return storeFileRefreshment(data).then((response) => {
    return response
  })
}

const saveInfoPax = (context, data) => {
  return storeReceiptMealPlan(data).then((response) => {
    return response
  })
}

const getMealPlanReceiptInfo = (context) => {
  getListMealPlanReceiptInfo().then((response) => {
    context.commit('MEAL_PLAN_RECEIPT_INFO', response)
  })
}

const getListCurrency = (context, data) => {
  getCurrencies(data).then((response) => {
    _.filter(response, function (o) {
      return o.payInAllowed
    })
    context.commit(
      'UPDATE_CURRENCIES',
      _.filter(response, function (o) {
        return o.payInAllowed
      })
    )
  })
}

const getListCountry = (context) => {
  return getCountrys().then((response) => {
    if (response) {
      context.commit('UPDATE_COUNTRYS', response)
    }
    return response
  })
}

const changeCurrency = (context, data) => {
  return getDataBank(data).then((response) => {
    if (response?.success) {
      context.commit('UPDATE_DATA_BANK', response.data)
    }
    return response
  })
}

const updateDataField = (context, data) => {
  return getDataFields(data).then((response) => {
    if (response?.success) {
      context.commit('UPDATE_DATA_BANK', response.data)
    }
  })
}

const getPriceRef = (context, refreshmentId) => {
  return getPricePersonRefreshment(refreshmentId).then((response) => {
    let dataRefreshments = _.filter(response, function (o) {
      return o.service_id == 2
    })
    context.commit('REFRESHMENT_PRICE', dataRefreshments)
    return dataRefreshments
  })
}

const checkValidator = (context, data) => {
  return checkValidatorField(data).then((response) => {
    return response
  })
}

const getMealPlanByVoucherCode = (context, object) => {
  return getMealPlanReceiptByVoucherCode(object.voucher_code).then((response) => {
    context.commit('MEAL_PLAN_RECEIPT_INFO_BY_VOUCHER_CODE', response)
    return response
  })
}

export default {
  // getRefreshment,
  uploadImg,
  saveInfoPax,
  getMealPlanReceiptInfo,
  getListCurrency,
  changeCurrency,
  updateDataField,
  getPriceRef,
  checkValidator,
  getListCountry,
  getMealPlanByVoucherCode,
  getInfoMealPlan,
  resetMealPlanInfo
}
